import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Table from '../../../core-components/theme/components/Table/Table';
import NoDataView from '../../../globalComponents/NoDataView/NoDataView';
import { columns } from '../helper/tableHelper';
import { useLogbookTable } from '../hooks/useLogbookListTable';

export default function LogbookListTable({ searchString }: any) {
    const { t } = useTranslation();
    const { logbooks, lastElementRef, tableContainerRef, queryKey } = useLogbookTable(searchString);
    const tableColumns = columns(queryKey, t) as any;
    const hasNoData = !logbooks || logbooks.length === 0;

    return (
        <Box ref={tableContainerRef} sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {hasNoData ? (
                <NoDataView message={t('common.noDataAvailable', 'No data available')} />
            ) : (
                <Table
                    stickyHeader
                    rows={logbooks}
                    columns={tableColumns}
                    lastRowRef={lastElementRef as any}
                />
            )}
        </Box>
    );
}